import $store from '@/store.js'
import Tool from './utils'
export function jumpLoginPage () {
  // 登出时白名单匹配
  console.log($store.state.common.baseUrl)
  const { authServerName, newUserServiceUrl, newTvuccUrl, newuserserviceLoginUrl, customeDirect, useCdn, xDomain } = $store.state.common.baseUrl ? $store.state.common.baseUrl : JSON.parse(localStorage.getItem('newCCInitConfig')).urlInfo
  let urlArr = newuserserviceLoginUrl
  let curUrl
  if (urlArr) {
    for (let i = 0; i < urlArr.length; i++) {
      if (urlArr[i].cc == window.location.host) {
        curUrl = urlArr[i]
        break
      }
    }
  }
  const filterArr = customeDirect ? customeDirect.filter(v => location.hostname.includes(v.domain)) : []
  if (curUrl) {
    const protocol = window.location.protocol
    // 有匹配的按匹配方式跳转
    window.location.href = `${protocol}//${curUrl.userservice}/newuserservice/?url=${protocol}//${curUrl.cc}/tvucc&serviceName=${authServerName}`
  } else if (filterArr.length) {
    window.location.href = filterArr[0].loginUrl
  } else {
    // 如果没有匹配的按老方式跳转
    window.location.href = `${newUserServiceUrl}/?url=${useCdn && xDomain ? xDomain : newTvuccUrl}/&serviceName=${authServerName}`
  }
  window.localStorage.setItem('NewCCsession3.0', '')
  window.sessionStorage.setItem('userChangeInfo', '')
  // Config-T会存入TSID，在登出时应该清空
  Tool.clearTSID()
}

// activate 页专用登出跳转：SID 无效(401/402)时跳登录服务，登录后回到公网 activate 入口。
// 登录服务 host 复用 jumpLoginPage 的解析（newuserserviceLoginUrl 按当前 cc host 匹配 → {userservice}/newuserservice；
// 无匹配时用 newUserServiceUrl，仍缺省则用硬编码默认），不依赖新增字段 newLoginServiceUrl。
// 返回地址、serviceName 走「配置优先、缺省默认」：
//   - 返回地址(公网入口)：baseUrl.activateReturnUrl ?? https://cc-dev.tvunetworks.com/activate
//   - serviceName：baseUrl.authServerName ?? Command Center
// 最终：{loginBase}/?url={returnUrl}&serviceName={encoded}#/signIn
export function jumpActivateLogin () {
  const cached = localStorage.getItem('newCCInitConfig')
  const info = $store.state.common.baseUrl || (cached ? JSON.parse(cached).urlInfo : {}) || {}
  const protocol = window.location.protocol
  // 复用 jumpLoginPage 的登录服务 host 解析
  let curUrl
  const urlArr = info.newuserserviceLoginUrl
  if (urlArr) {
    for (let i = 0; i < urlArr.length; i++) {
      if (urlArr[i].cc == window.location.host) {
        curUrl = urlArr[i]
        break
      }
    }
  }
  const loginBase = curUrl
    ? `${protocol}//${curUrl.userservice}/newuserservice`
    : (info.newUserServiceUrl || 'https://cc-ms-dev.tvunetworks.com/newuserservice')
  const returnUrl = info.activateReturnUrl || 'https://cc-dev.tvunetworks.com/activate'
  const serviceName = info.authServerName || 'Command Center'
  window.location.href = `${loginBase}/?url=${returnUrl}&serviceName=${encodeURIComponent(serviceName)}#/signIn`
  window.localStorage.setItem('NewCCsession3.0', '')
  window.sessionStorage.setItem('userChangeInfo', '')
  Tool.clearTSID()
}

export function redirectUrl () {
  // 登录时白名单匹配
  const { mySourceUrl, customeDirect, useCdn, xDomain } = $store.state.common.baseUrl ? $store.state.common.baseUrl : JSON.parse(localStorage.getItem('newCCInitConfig')).urlInfo
  let urlVal = mySourceUrl || ''
  const filterArr = customeDirect ? customeDirect.filter(v => location.hostname.includes(v.domain)) : []
  if (urlVal && location.hostname != urlVal && !filterArr.length) {
    let hostVal = ''
    hostVal = useCdn && xDomain ? `${xDomain}/${location.hash}${location.search}` : `${window.location.protocol}//${mySourceUrl}/${location.hash}${location.search}`
    if (process.env.NODE_ENV === 'production') location.href = hostVal
  } else if (filterArr.length) {
    location.href = filterArr[0].loginUrl
  } else {
    location.href = `${location.origin}${location.pathname}${location.hash}${location.search}`
  }
}
